import { request } from '@langlois/request';

export async function createFees ({ commit, getters }, { competitionId, data }) {
	try {
		const body = new FormData();

		for (let [key, value] of Object.entries(data)) {
			if (value) body.append(key, value);
		}

		const url = new URL(`${process.env.VUE_APP_API_URI}/club/competition/${competitionId}/fee`);

		const response = await request.post(url, body);

		if (response.ok) {
			const competition = getters[`getById`](competitionId);

			commit(`setCompetition`, {
				...competition,
				fees: {
					...competition.fees,
					...data
				}
			});
		}
	} catch (error) {
		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while creating the fee.`,
			type: `warning`
		}, { root: true });
	}
}
